import { RootState } from "store/store";

export const selectFilterRole = (state: RootState) => state.filterrole.role;
export const selectFilterRoleMembersCount = (state: RootState) =>
  state.filterrole.roleMembersCount;
export const selectFilterRoleOptions = (state: RootState) =>
  state.filterrole.roleOptions;
export const selectFilterRoleCreationStatus = (state: RootState) =>
  state.filterrole.roleCreationStatus;
export const selectFilterRoleRequestStatus = (state: RootState) =>
  state.filterrole.roleRequestStatus;
export const selectFilterRoleOptionsRequestStatus = (state: RootState) =>
  state.filterrole.roleOptionsRequestStatus;
export const selectFilterRoleUpdateStatus = (state: RootState) =>
  state.filterrole.roleUpdateStatus;
export const selectFilterRoleDeletionStatus = (state: RootState) =>
  state.filterrole.roleDeletionStatus;
export const selectMembersUpdateStatus = (state: RootState) =>
  state.filterrole.membersUpdateStatus;
export const selectSwitchMemberStatus = (state: RootState) =>
  state.filterrole.switchMemberStatus;
